module.exports = __webpack_public_path__ + "static/media/availability-slide-2.8125b0ae.jpg";